import React from "react";
import { IModalProps, Modal } from "../../../seenspire-library";
import {
  Container,
  EmptyPlaceholderIcon,
  ModalCustomStyles,
  ModalDescription,
  ModalSubtitle,
  ModalTitle,
  StyledCtaButton,
} from "./styles";

interface NoCreatedDataModalProps extends IModalProps {
  onSubmit: () => void;
  title: string;
  description: string;
  subtitle: string;
  buttonText: string;
  image: any;
}

const NoCreatedDataModal = (props: NoCreatedDataModalProps) => {
  const { onSubmit, title, description, subtitle, buttonText, image } = props;

  return (
    <Modal customStyle={ModalCustomStyles} {...props}>
      <Container>
        <ModalTitle>{title}</ModalTitle>
        {image}
        <ModalSubtitle color="gray">{subtitle}</ModalSubtitle>
        <ModalDescription color="gray">{description}</ModalDescription>
        <StyledCtaButton
          onClick={onSubmit}
          buttonType="cta"
          elementWidth="block"
        >
          {buttonText}
        </StyledCtaButton>
      </Container>
    </Modal>
  );
};

export default NoCreatedDataModal;
